import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  loading,
  tipovi,
}) => {
  const { t, i18n } = useTranslation();
  // Map tipovi to a dictionary for quick lookup
  const updatedData = data.map((item) => {
    const tip = tipovi.find((tip) => tip.id === item.tip);
    return {
      ...item,
      nazivTipa: tip ? tip.vrednost : '', // If tip is found, use nazivTipa from tipovi, otherwise set to ''
    };
  });
  console.log(updatedData);
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'naziv', headerName: t('name'), width: 200 },
    { field: 'jm', headerName: t('unitOfMeasure'), width: 200 },
    { field: 'nazivTipa', headerName: t('type'), width: 200 },
    {
      field: 'cenaTehnicar',
      headerName: t('priceTechnician'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'cenaInzenjer',
      headerName: t('priceEngineer'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'cenaTehnicarIno',
      headerName: t('priceTechnicianIno'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'cenaInzenjerIno',
      headerName: t('priceEngineerIno'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
  ];

  return (
    <div style={{ height: '75vh', width: '99%' }}>
      <MuiGrid data={updatedData} columns={columns} loading={loading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
